import { CellEditRequestEvent, ICellRendererParams } from "ag-grid-community";
import {
  FlatProduct,
  isOverlappedValue,
  OverlappedValue,
} from "@/features/line-sheet-sets/helpers/sheet-state";
import {
  isPriceAdjustedByType,
  PriceAdjustedBy,
} from "@/features/line-sheet-sets/line-sheet-set.types";
import { useCallback, useMemo } from "react";
import AppSelect from "@/features/line-sheet-sets/app-select";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { Text } from "@chakra-ui/react";
import { AgGridUtils } from "@/features/ui/utils/ag-grid-utils";

export interface ConditionTypeCellProps {
  isEditable?: boolean;
  isConditionFixed?: boolean;
  // true면 isConditionFixed를 무시하고 (isEditable일 때) 항상 편집 가능.
  // 에이전시 화면에서만 true로 넘긴다(buyer는 fixed면 잠금 유지).
  ignoreConditionFixed?: boolean;
  applyIva?: boolean | null;
}

export default function OverlappedConditionTypeCell(
  props: ConditionTypeCellProps &
    ICellRendererParams<
      FlatProduct,
      PriceAdjustedBy["by"] | OverlappedValue<PriceAdjustedBy["by"]>
    >
) {
  const { value, isEditable, isConditionFixed, ignoreConditionFixed, applyIva } =
    props;
  const { tTitle } = useI18nHelper();
  const [top, under] = useMemo(() => {
    if (isOverlappedValue(value, isPriceAdjustedByType)) {
      return [value.top, value.under] as const;
    } else {
      return [value, undefined];
    }
  }, [value]);

  const isContentOverlapped = under !== undefined && top != under;

  const options = useMemo((): AppSelectOption<PriceAdjustedBy["by"]>[] => {
    const values: PriceAdjustedBy["by"][] = ["MARKUP", "DISCOUNT"];
    return values.map((item) => {
      let str = item.substring(0, 1) + item.substring(1).toLowerCase();
      // if (applyIva && item === "DISCOUNT") {
      //   str += "(+IVA)";
      // }
      return {
        name: str,
        component:
          item != under && under ? (
            <Text textAlign={"center"} color={"#1272EF"}>
              {str}
            </Text>
          ) : (
            <Text textAlign={"center"}>{str}</Text>
          ),
        value: item,
      };
    });
  }, [under]);

  const handleSelect = useCallback(
    (newValue?: PriceAdjustedBy["by"]) => {
      AgGridUtils.dispatchCellEditEvent(newValue, props);
    },
    [props]
  );

  return (
    <AppSelect<PriceAdjustedBy["by"]>
      height={"22px"}
      name={tTitle("common:condition")}
      value={top}
      isLiteral={!(isEditable && (ignoreConditionFixed || !isConditionFixed))}
      options={options}
      onSelect={handleSelect}
      isClearable={false}
    />
  );
}
